import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const signUpDriver = ({
  firstName,
  lastName,
  phone,
  email,
  driverLicense,
  smartserve,
  password,
}) =>
  axios({
    method: 'post',
    url: `${publicAPI}/registration/driver`,
    data: {
      firstName,
      lastName,
      phone,
      email,
      driverLicense,
      smartserve,
      password,
    },
  });
